export default "__VITE_ASSET__CFG$Sy9S__"